module.exports = __webpack_public_path__ + "src/assets/sounds/latex_gloves_sound.mp3";